"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateIncapacitatedDisclaimerNecessary = exports.calculateHealthQuestionsNecessary = exports.calculateHealthQuestionsRelevant = exports.calculateIsIncapacitated = void 0;
const common_1 = require("../common");
const Homesteaders = 'homesteaders';
const isTrust = (productType) => {
    return productType === common_1.FundingProductType.Trust;
};
const shouldDefaultToIncapacitated = (selectedFundingProduct) => {
    // Homesteaders 600's are always incapacitated
    return (selectedFundingProduct.provider.toLowerCase() === Homesteaders &&
        selectedFundingProduct.contractId.startsWith('6'));
};
const insuredIsIncapacitated = (healthHistoryQuestions) => {
    return healthHistoryQuestions.isBedriddenOrAiled || healthHistoryQuestions.wasBedriddenOrAiledInLastFiveYears;
};
const productNeedsHealthQuestions = (selectedFundingProduct) => {
    return (selectedFundingProduct.contractId &&
        selectedFundingProduct.contractId.startsWith('2') &&
        selectedFundingProduct.provider.toLowerCase() === Homesteaders);
};
function calculateIsIncapacitated(selectedFundingProduct, healthHistoryQuestions) {
    // With the current product, everyone gets incapacitated rates
    return (!isTrust(selectedFundingProduct.productType) &&
        (shouldDefaultToIncapacitated(selectedFundingProduct) || insuredIsIncapacitated(healthHistoryQuestions)));
}
exports.calculateIsIncapacitated = calculateIsIncapacitated;
function calculateHealthQuestionsRelevant(selectedFundingProduct, timing, selectedPaymentMode) {
    if (timing === common_1.Timing.Immediate) {
        return false;
    }
    return (!isTrust(selectedFundingProduct.productType) &&
        productNeedsHealthQuestions(selectedFundingProduct) &&
        selectedPaymentMode === common_1.PaymentMode.Multi);
}
exports.calculateHealthQuestionsRelevant = calculateHealthQuestionsRelevant;
function calculateHealthQuestionsNecessary(selectedFundingProduct, timing, selectedPaymentMode, healthHistoryQuestions) {
    // Homesteaders 200 contracts get health questions
    return (calculateHealthQuestionsRelevant(selectedFundingProduct, timing, selectedPaymentMode) &&
        (healthHistoryQuestions.isBedriddenOrAiled === undefined ||
            healthHistoryQuestions.wasBedriddenOrAiledInLastFiveYears === undefined));
}
exports.calculateHealthQuestionsNecessary = calculateHealthQuestionsNecessary;
function calculateIncapacitatedDisclaimerNecessary(selectedFundingProduct, selectedPaymentMode, healthHistoryQuestions, hasBeenAcceptedOrPositivelyAddressed) {
    // TODO this param needs addressed
    return (selectedPaymentMode === common_1.PaymentMode.Multi &&
        calculateIsIncapacitated(selectedFundingProduct, healthHistoryQuestions) &&
        !hasBeenAcceptedOrPositivelyAddressed);
}
exports.calculateIncapacitatedDisclaimerNecessary = calculateIncapacitatedDisclaimerNecessary;
//# sourceMappingURL=healthHistoryQuestions.js.map